import React from "react";
import demoImg from "./assets/demo.webp";

function DemoSection() {
  return (
    <section className='demo-section'>
      <div className='demo-inner'>
        <div className='demo-text-col'>
          <h2>Let us show you how it's done</h2>
          <p>
            If a picture is worth a thousand words, a demo is worth a thousand
            pictures. That's why before you do anything, I want you to see AI in
            action. This demo gives a taster of how AI engages with customers in
            a natural way and bears the brunt of repetitive tasks, so you and
            your team don't have to.
          </p>
          <p>
            With AI freeing up valuable man-power and doing the work you'd
            "never get around to doing", you can unlock new levels of ROI whilst
            focusing on the things you enjoy.
          </p>
        </div>
        <div className='demo-image-col'>
          <img src={demoImg} alt='AI Demo' className='demo-image' />
        </div>
      </div>
    </section>
  );
}

export default DemoSection;
